import { FreeCoursesAndCertification as Banner } from '@sbercloud/uikit-product-site-banner-predefined';
import { SectionBasic } from '@sbercloud/uikit-product-site-section';
import { usePathname, useRouter } from 'next/navigation';
import { MouseEvent } from 'react';
import { useAnalytics } from 'src/hooks/useAnalytics';
import { useLayoutType } from 'src/hooks/useLayoutType';

export type FreeCoursesAndCertificationBannerData = {
  id?: string;
  variant: 'FreeCoursesAndCertification';
  buttonMainHref?: string;
};

export function FreeCoursesAndCertification(
  props: FreeCoursesAndCertificationBannerData,
) {
  const { id, buttonMainHref } = props;

  const { clickAnalytics } = useAnalytics();
  const layoutType = useLayoutType();
  const pathname = usePathname();
  const root = pathname?.split('/')[1];
  const router = useRouter();

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (!buttonMainHref) return;

    clickAnalytics({
      action: buttonMainHref,
      clickZone: 'body',
      clickElement: 'button',
      clickContent: 'banner-button-content',
      uniqueId: `${root}-banner-button-main`,
      transitionType: 'inside-link',
      clickZoneCategory: 'site-body',
      transitionUrl: buttonMainHref,
      transitionTypeMetrics: 'internal',
    });

    router.push(buttonMainHref);
  };

  return (
    <SectionBasic id={id} layoutType={layoutType}>
      <Banner
        href={buttonMainHref}
        layoutType={layoutType}
        onClick={handleClick}
      />
    </SectionBasic>
  );
}
